function setRememberMeCookie(customer_id) {
    var daysToExpire = 7; // Number of days until the cookie expires
    var date = new Date();
    date.setTime(date.getTime() + (daysToExpire * 24 * 60 * 60 * 1000));
    var expires = "expires=" + date.toUTCString();
    document.cookie = "remember_me=" + customer_id + ";" + expires + ";path=/";
}

function handleFormSubmit(event) {
    event.preventDefault();
        var customer_id = document.getElementById('customer_id').value;
        setRememberMeCookie(customer_id);
  
    
    // Submit the form as normal
}

document.getElementById('customer_login').addEventListener('submit', handleFormSubmit);